import script from "./consultationRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./consultationRecord.vue?vue&type=script&setup=true&lang=ts"

import "./consultationRecord.vue?vue&type=style&index=0&id=587b80e0&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587b80e0"]])

export default __exports__